export async function readFetchError(response: Response): Promise<string> {
  try {
    const body = await response.json();
    if (body && typeof body === 'object') {
      const record = body as Record<string, unknown>;
      const message = record.error || record.message || record.details;
      if (typeof message === 'string' && message.trim()) return message.trim();
    }
  } catch {
    // response body was not JSON
  }
  if (response.statusText) return `${response.statusText} (HTTP ${response.status})`;
  return `HTTP ${response.status}`;
}
